import { render, staticRenderFns } from "./I18nTests.vue?vue&type=template&id=13344d6e&"
import script from "./I18nTests.vue?vue&type=script&lang=js&"
export * from "./I18nTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports